<template>
  <div class="action_line fixed_line">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>
